import words from 'lodash/words';

export const isEmpty = (text: string = ''): boolean => {
  return getTextContent(text).trim() === '';
};

export const getTextContent = (text: string = ''): string => {
  const tempNode = document.createElement('div');
  // eslint-disable-next-line no-unsanitized/property
  tempNode.innerHTML = text;
  return tempNode.textContent || '';
};

/** Whether the text is too short for an AI action to work with. */
export const isInsufficientText = (text: string = ''): boolean => {
  return isEmpty(text) || words(text).length < 2 || text.trim().length < 6;
};
